import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Typography,
  Avatar,
} from "@material-tailwind/react";
import { useTranslation } from "react-i18next";

const TopCustomers = ({ data = [] }) => {
  const { t } = useTranslation("home");

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "SAR",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(amount || 0);
  };

  return (
    <Card className="shadow-md">

      <CardHeader
        floated={false}
        shadow={false}
        className="rounded-none bg-white px-6 py-4"
      >
        <Typography variant="h5">
          {t('topCustomers.title')}
        </Typography>

        <Typography
          variant="small"
          color="gray"
        >
          {t('topCustomers.description')}
        </Typography>

      </CardHeader>

      <CardBody className="px-0 pt-0 overflow-x-auto">

        <table className="w-full min-w-max table-auto ">

          <thead>

            <tr>

              <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4 text-left">
                {t('topCustomers.serialNumber')}
              </th>

              <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4 text-left">
                {t('topCustomers.company')}
              </th>

              <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4 text-center">
                {t('topCustomers.payments')}
              </th>

              <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4 text-right">
                {t('topCustomers.revenue')}
              </th>

            </tr>

          </thead>

          <tbody>

            {data.length === 0 && (

              <tr>

                <td
                  colSpan={4}
                  className="p-6 text-center text-gray-500"
                >
                  {t('topCustomers.noCustomerFound')}
                </td>

              </tr>

            )}

            {data.map((customer, index) => (

              <tr
                key={index}
                className="hover:bg-blue-gray-50 transition"
              >

                <td className="p-4">

                  <Typography
                    className="font-bold"
                  >
                    0{index + 1}
                  </Typography>

                </td>

                <td className="p-4">

                  <div className="flex items-center gap-3">

                    <Avatar
                      size="sm"
                      variant="circular"
                      src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
                        customer.company_name
                      )}`}
                    />

                    <div>

                      <Typography
                        variant="small"
                        className="font-semibold"
                      >
                        {customer.company_name}
                      </Typography>

                    </div>

                  </div>

                </td>

                <td className="p-4 text-center">

                  <Typography>

                    {customer.total_transactions}

                  </Typography>

                </td>

                <td className="p-4 text-right">

                  <Typography
                    color="green"
                    className="font-bold"
                  >

                    {formatCurrency(customer.total_paid)}

                  </Typography>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </CardBody>

    </Card>
  );
};

export default TopCustomers;